/* LÚM motion — scroll reveal, parallax hero, marquee dup. Editor-safe. */
(() => {
  'use strict';

  // Mark html for CSS to know JS is alive
  document.documentElement.classList.add('lum-js');

  // Mark Shopify editor design mode so CSS can disable animations
  if (window.Shopify && window.Shopify.designMode) {
    document.documentElement.classList.add('shopify-design-mode');
  }

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Scroll reveal */
  if (!reduceMotion && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -5% 0px' });

    const observe = () => {
      document.querySelectorAll('[data-lum-reveal]:not(.is-in)').forEach((el) => io.observe(el));
    };
    observe();
    new MutationObserver(observe).observe(document.body, { childList: true, subtree: true });

    // Safety net: after 1.5s, force-reveal anything still hidden in viewport
    setTimeout(() => {
      document.querySelectorAll('[data-lum-reveal]:not(.is-in)').forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          el.classList.add('is-in');
        }
      });
    }, 1500);
  } else {
    // No JS observer support → reveal everything immediately
    document.querySelectorAll('[data-lum-reveal]').forEach((el) => el.classList.add('is-in'));
  }

  /* Hero parallax */
  if (!reduceMotion) {
    const heroMedia = document.querySelectorAll('[data-lum-hero-media]');
    if (heroMedia.length) {
      let raf = null;
      const onScroll = () => {
        const y = window.scrollY;
        heroMedia.forEach((el) => {
          el.style.transform = `translate3d(0, ${y * 0.22}px, 0) scale(1.04)`;
        });
        raf = null;
      };
      window.addEventListener('scroll', () => {
        if (raf === null) raf = window.requestAnimationFrame(onScroll);
      }, { passive: true });
    }
  }

  /* Marquee duplication */
  const dupMarquees = () => {
    document.querySelectorAll('.lum-marquee__track').forEach((track) => {
      if (track.dataset.lumDup === 'done') return;
      track.innerHTML = track.innerHTML + track.innerHTML;
      track.dataset.lumDup = 'done';
    });
  };
  dupMarquees();

  /* Shopify theme editor: re-init on section load/reorder */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      document.querySelectorAll('[data-lum-reveal]').forEach((el) => el.classList.add('is-in'));
      dupMarquees();
    });
    document.addEventListener('shopify:section:reorder', () => {
      document.querySelectorAll('[data-lum-reveal]').forEach((el) => el.classList.add('is-in'));
    });
  }
})();
